<template>
    <div class="text-[1.2rem] text-primary px-3">
        <span>{{ vipname }}</span> <span>{{ levelname }}</span>
    </div>
    <br>
    <div class="md:grid md:grid-flow-col grid-cols-4 gap-2">
        <div
            class="flex flex-grow rounded ring-1 overflow-hidden transition-all duration-150 lg:hover:ring-green-600 mb-3 md:mb-0"
            @click="openPDF('bulb')"
        >
            <label class="cursor-pointer w-full">
                <div class="p-2.5 bg-green-100 text-center">
                    <span class="text-gray-900">VIP資格介紹<br>及服務總覽</span>
                </div>
                <div class="p-2.5 border-t text-base xs:text-lg transition-all duration-150 border-green-600">
                    <div class="pl-2">
                        <SvgIcon
                            icon-name="bulb-icon"
                            class="text-black w-12 h-12 mx-auto"
                        />
                    </div>
                </div>
            </label>
        </div>
        <div
            class="flex flex-grow rounded ring-1 overflow-hidden transition-all duration-150 lg:hover:ring-green-600 mb-3 md:mb-0"
            @click="openPDF('gift')"
        >
            <label class="cursor-pointer w-full">
                <div class="p-2.5 bg-green-100 text-center">
                    <span class="text-gray-900">VIP特約商店<br>優惠方案</span>
                </div>
                <div class="p-2.5 border-t text-base xs:text-lg transition-all duration-150 border-green-600">
                    <div class="pl-2">
                        <SvgIcon
                            icon-name="gift-icon"
                            class="gift-icon w-12 h-12 mx-auto"
                        />
                    </div>
                </div>
            </label>
        </div>
        <div
            class="flex flex-grow rounded ring-1 overflow-hidden transition-all duration-150 lg:hover:ring-green-600 mb-3 md:mb-0"
            @click="openPDF('medical')"
        >
            <label class="cursor-pointer w-full">
                <div class="p-2.5 bg-green-100 text-center">
                    <span class="text-gray-900">健檢服務項目<br>(富樂/富御VIP)</span>
                </div>
                <div class="p-2.5 border-t text-base xs:text-lg transition-all duration-150 border-green-600">
                    <div class="pl-2">
                        <SvgIcon
                            icon-name="medical-icon"
                            class="text-black w-12 h-12 mx-auto"
                        />
                    </div>
                </div>
            </label>
        </div>
        <div
            class="flex flex-grow rounded ring-1 overflow-hidden transition-all duration-150 lg:hover:ring-green-600 mb-3 md:mb-0"
            @click="openPDF('book')"
        >
            <label class="cursor-pointer w-full">
                <div class="p-2.5 bg-green-100 text-center">
                    <span class="text-gray-900">115年貴賓保戶<br>服務手冊</span>
                </div>
                <div class="p-2.5 border-t text-base xs:text-lg transition-all duration-150 border-green-600">
                    <div class="pl-2">
                        <SvgIcon
                            icon-name="book-icon"
                            class="text-black w-12 h-12 mx-auto"
                        />
                    </div>
                </div>
            </label>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, inject, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import routeName from '@/router/constant.js';
import { getInfoVIP } from '@/apis/vipBirth';

export default {
    setup() {
        const $vfm = inject('$vfm');
        const store = useStore();
        const router = useRouter();
        const isLoading = ref(false);
        const vipname = ref('');
        const levelname = ref('');
        const isLogin = store.state.permissions.authExternal;
        const users = reactive({
            type: 'M',
            mobile: '',
            choose: '',
            email: '',
            mobileList: [],
            emailList: [],
            counting: false,
            otpCode: '',
            sendTimes: 0,
            errorMsg: '',
            verifyErrorTimes: 0,
        });
        const clearValue = () => {
            if (users.type === 'M') {
                users.email = '';
            } else {
                users.mobile = '';
            }
        };

        if (isLogin !== 'Y') {
            sessionStorage.clear();
            router.push({ name: routeName.NO_AUTH });
        }

        const openPDF = (args) => {
            const path = process.env.VUE_APP_CONTEXT_PATH;
            const baseUrl = `${window.location.origin}${path}`;
            if (args === 'bulb') {
                window.open(baseUrl + '/vip/bulb.pdf', '_blank');
            }
            if (args === 'gift') {
                window.open(baseUrl + '/vip/gift.pdf', '_blank');
            }
            if (args === 'medical') {
                window.open(baseUrl + '/vip/medical.pdf', '_blank');
            }
            if (args === 'book') {
                window.open(baseUrl + '/vip/book.pdf', '_blank');
            }
        };

        const vipInfo = () => {
            return getInfoVIP().then(res => {
                if (res.data) {
                    vipname.value = res.data.name;
                    levelname.value = res.data.levelname;
                }
            }).catch(err => {
                openPopup(err.data.errorMessage);
            });
        };
        vipInfo();
        const openPopup = (errorMessage) => {
            $vfm.show({
                component: 'DialogBase',
                params: {
                    title: '系統提示',
                    content: errorMessage || '系統忙碌中，請稍後再試',
                    confirmButton: '確認',
                    cancelButton: null,
                    closeicon: true,
                },
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    },
                }
            });
        };

        return {
            ...toRefs(users),
            isLoading,
            vipname,
            levelname,
            openPDF,
            clearValue
        };
    },
};
</script>
<style lang="scss" scoped>
:deep(.multiselect-option) {
    @apply break-all;
}
</style>
